/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */
export class MapUtils {

  public static getDistanceBetweenTwoLatLngPoints(lat1: any, lng1: any, lat2: any, lng2: any): number {
    const p = 0.017453292519943295;    // Math.PI / 180
    const c = Math.cos;
    const a = 0.5 - c((lat2 - lat1) * p) / 2 +
      c(lat1 * p) * c(lat2 * p) *
      (1 - c((lng2 - lng1) * p)) / 2;

    return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
  }

  public static decodePolyline(encodedPathLocation: any): google.maps.LatLng[] {
    if(google) {
      return google.maps.geometry.encoding.decodePath(encodedPathLocation);
    }
  }

  public static encodePolyline(path: google.maps.LatLng[]): string {
    if(google) {
      return google.maps.geometry.encoding.encodePath(path);
    }
  }

}
